// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import ToTopIcon from 'assets/icons/to-top.svg'
import styles from './ScrollButton.module.scss'

export const ScrollButton = ({
  handleScrollToTop,
  scrollPosition,
  showFromTopPosition = 600,
  containerClassName = undefined,
  buttonClassName = undefined,
}) => {
  return (
    <div
      className={cx(styles.stickyContainer, {
        [styles.show]: scrollPosition?.scrollTop > showFromTopPosition,
        [containerClassName]: Boolean(containerClassName),
      })}
    >
      <button
        className={cx(styles.scrollButton, {
          [buttonClassName]: Boolean(buttonClassName),
        })}
        onClick={handleScrollToTop}
      >
        <img src={ToTopIcon} alt="scroll to top" />
      </button>
    </div>
  )
}
